import React, { createContext, useContext, useMemo } from 'react';
import { getFeatureFlags } from '../config/featureFlags';

const FeatureFlagContext = createContext(getFeatureFlags());

export const FeatureFlagProvider = ({ overrides = {}, children }) => {
  const flags = useMemo(() => {
    const merged = { ...getFeatureFlags(), ...overrides };
    Object.keys(merged).forEach((key) => {
      if (typeof merged[key] !== 'boolean') {
        delete merged[key];
      }
    });
    return merged;
  }, [overrides]);

  return (
    <FeatureFlagContext.Provider value={flags}>
      {children}
    </FeatureFlagContext.Provider>
  );
};

export const useFeatureFlags = () => useContext(FeatureFlagContext);


